// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B4kl","col":"styles_col__2dVlG","actions":"styles_actions__yWgTD","conflict":"styles_conflict__j-A57"};